"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = void 0;
const symbols_1 = require("./symbols");
function patch(arg) {
    if (!Symbol.observable) {
        if (typeof arg === "function" &&
            arg.prototype &&
            arg.prototype[Symbol.observable]) {
            arg.prototype[symbols_1.observable] = arg.prototype[Symbol.observable];
            delete arg.prototype[Symbol.observable];
        }
        else {
            arg[symbols_1.observable] = arg[Symbol.observable];
            delete arg[Symbol.observable];
        }
    }
    return arg;
}
exports.patch = patch;
//# sourceMappingURL=patch.js.map